import React from "react";
import MainLoader from "../MainLoader";

const CategoriesListLoader = () => {
    return (
        <MainLoader />
    )
}

export default CategoriesListLoader;